import {Controller} from "stimulus"
import $ from 'jquery';
import {setSessionVar} from "./sessionStorage_controller";
import {preferences} from "./preferences_controller";
import {blockElementsById, unBlockElementById} from "./blockUI_controller";
import {create_array_for_product} from "./b2b_controller";

export let get_contract = (box_block = null, dealer) => new Promise((resolve, reject) => {
    preferences('url_contracts', 'url').then(
        result => {
            let dealer_prod_type = '';
            let prod_type = '';

            if (create_array_for_product('product_type', '', 'show') === 'car' || create_array_for_product('product_type', '', 'show') === 'campers' || create_array_for_product('product_type', '', 'show') === 'bike') {
                dealer_prod_type = dealer || create_array_for_product('dealer', '', 'show');
            } else {
                dealer_prod_type = dealer || create_array_for_product('dealer_code', '', 'show');

                if (create_array_for_product('product_type', '', 'show') === 'home') {
                    prod_type = 'home'
                }
            }

            $.ajax({
                url: location.origin + '/contracts_by_dealer',
                data: {
                    /*dealer: dealer || create_array_for_product('dealer_code','','show')*/
                    dealer: dealer_prod_type,
                    prod_type: prod_type
                },
                // FIX (2026-08-10): dataType 'json' + timeout: una respuesta HTML (caso /offline)
                // o un servidor que no responde caen al handler error: en vez de colgar la promesa.
                dataType: 'json',
                timeout: 30000,
                beforeSend: function () {
                    if (box_block !== null) {
                        blockElementsById(box_block, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>${I18n.t('global.main.form.message.search_contract')}</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
                    }
                },
                success: function (data) {
                    // FIX (2026-08-05): /contracts_by_dealer puede devolver null (contrato no
                    // configurado o inexistente) o ["Error": ...]. No acceder a data.code_number
                    // en ese caso para no lanzar TypeError.
                    if (data === null || data.code_number === undefined || data.code === undefined) {
                        if (box_block !== null) {
                            unBlockElementById(box_block);
                        }
                        // Limpiar el contrato previo: sin esto get_tariffs usaría datos stale
                        // y seguiría a /tariff con un contrato que ya no aplica.
                        create_array_for_product('contract_code_number', '', 'delete');
                        create_array_for_product('contract_code', '', 'delete');
                        // Mostrar el error real del servidor (o mensaje genérico) aunque el
                        // caller no revise gcontract.next (p. ej. flujo del home).
                        let contract_error = (data && data[0] && data[0]['Error'])
                            ? data[0]['Error']
                            : I18n.t('main.header.shopping_cart.selling_contract_text');
                        toastr.error(contract_error, I18n.t('main.header.shopping_cart.selling_contract'));
                        resolve({
                            next: false
                        });
                        return;
                    }

                    create_array_for_product('contract_code_number', data.code_number);
                    create_array_for_product('contract_code', data.code);

                    resolve(
                        {
                            data: data,
                            next: true
                        }
                    )
                },
                error: function (xhr, status, error) {
                    // FIX (2026-08-10): antes solo resolvía {next:false} en silencio y el overlay
                    // del formulario quedaba puesto para siempre. Ahora desbloquea y avisa.
                    if (box_block !== null) {
                        unBlockElementById(box_block);
                    }
                    toastr.error(I18n.t('global.main.form.message.request_error'), I18n.t('global.main.form.message.request_error_title'));
                    resolve({
                        next: false
                    })
                }
            })
        }
    )
});

export let get_tariffs = (box_block = null) => new Promise((resolve, reject) => {
    // FIX (2026-08-05): no llamar a /tariff si no hay contrato previo (get_contract falló o no
    // se ejecutó). Evita el error "Bad contract number params" y corta la cadena: varios callers
    // (home, car, bike, campers, sortable) llaman get_tariffs sin verificar get_contract.next.
    if (create_array_for_product('contract_code_number', '', 'show') === undefined) {
        if (box_block !== null) {
            unBlockElementById(box_block);
        }
        resolve({
            next: false
        });
        return;
    }        $.ajax({
        url: location.origin + '/tariff',
        data: {
            url: 'url_tariff_by_contracts'
        },
        // FIX (2026-08-10): idem get_contract. Con dataType 'json' el HTML de /offline cae a error:.
        dataType: 'json',
        timeout: 30000,
        beforeSend: function () {
            if (box_block !== null) {
                blockElementsById(box_block, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>${I18n.t('global.main.form.message.search_tariff')}</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');

            }
        },
        success: function (tariffs_data) {
            // FIX (2026-08-10): guard null-safe. Con dataType 'json' el HTML ya cae a error:,
            // pero una respuesta null/vacía llega aquí y rompía con tariffs_data[0]['Error'].
            if (tariffs_data === null || typeof tariffs_data !== 'object' || (tariffs_data.code === undefined && tariffs_data.name === undefined)) {
                if (box_block !== null) {
                    unBlockElementById(box_block);
                }
                let tariff_error = (tariffs_data && tariffs_data[0] && tariffs_data[0]['Error'])
                    ? tariffs_data[0]['Error']
                    : I18n.t('main.header.shopping_cart.selling_price_text');
                toastr.error(tariff_error, I18n.t('main.header.shopping_cart.selling_price'));

                resolve({
                    next: false
                })
            } else {
                create_array_for_product('tariff_code', tariffs_data.code)
                create_array_for_product('tariff_name', tariffs_data.name)

                resolve({
                    data: tariffs_data,
                    next: true
                })
            }
        },
        error: function (xhr, status, error) {
            // FIX (2026-08-10): desbloquear y avisar en vez de resolver en silencio.
            if (box_block !== null) {
                unBlockElementById(box_block);
            }
            toastr.error(I18n.t('global.main.form.message.request_error'), I18n.t('global.main.form.message.request_error_title'));
            resolve({
                next: false
            })
        }
    })
})

export let get_modalities = (box_block = null, dealer, product, amount, save = true) => new Promise((resolve, reject) => {
    preferences('url_modalities', 'url').then(
        modalities => {
            $.ajax({
                url: location.origin + '/modalities_by_dealer',
                data: {
                    dealer: dealer,
                    product: product,
                    max_amount: amount
                },
                dataType: 'json',
                timeout: 30000,
                beforeSend: function () {
                    if (box_block !== null) {
                        blockElementsById(box_block, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>${I18n.t('global.main.form.message.search_modality')}</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');

                    }
                },
                success: function (modalities_data) {
                    if (save) {
                        create_array_for_product('modality_code', modalities_data.code)
                        create_array_for_product('modalities_name', modalities_data.name)
                    }

                    resolve({
                        next: true,
                        data: modalities_data
                    })
                },
                error: function (xhr, status, error) {
                    // FIX (2026-08-10): desbloquear y avisar en vez de resolver en silencio.
                    if (box_block !== null) {
                        unBlockElementById(box_block);
                    }
                    toastr.error(I18n.t('global.main.form.message.request_error'), I18n.t('global.main.form.message.request_error_title'));
                    resolve({
                        next: false
                    })
                }
            })
        }
    )
})

export default class extends Controller {
}